























































import { Component, Vue } from 'vue-property-decorator'
import { getLoad, cancelEnrol } from '@/api/exchange'
import { formatDate } from '@/utils/tool.ts'
import chooseProduct from '@/components/ChooseProduct/index.vue'
@Component({
  name: 'LiveDetail',
  components: {
    chooseProduct
  }
})
export default class Live extends Vue {
  private loading = false
  private detail = {}
  private isShow = false
  private arr: any[] = []

  created () {
    this.getLoad()
  }

  // 获取直播详情
  async getLoad () {
    const res = await getLoad(this.$route.query.id)
    this.detail = res.data
  }

  // 取消报名
  cancel (item) {
    const startDate = formatDate(item.liveStartDate)
    const h = this.$createElement
    this.$msgbox({
      title: '提示',
      message: h('p', null as any, [
        h('span', null as any, '确定要取消'),
        h('span', '(' + startDate + ')' + ' ' + '(' + '主题：' + item.title + ')'),
        h('span', null as any, '活动商品报名么？')
      ]),
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      beforeClose: (action, instance, done) => {
        if ((action as any) === 'confirm') {
          instance.confirmButtonLoading = true
          instance.confirmButtonText = '执行中...'
          setTimeout(() => {
            done()
            setTimeout(() => {
              instance.confirmButtonLoading = false
            }, 300)
          }, 1000)
        } else {
          done()
        }
      }
    }).then(() => {
      const { id } = item
      cancelEnrol(id).then(res => {
        if (res && res.state === 'success') {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.getLoad()
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    }).catch(() => {
      console.log('已取消')
    })
  }

  // 选择产品回调
  changeProduct () {
    this.isShow = false
    this.getLoad()
  }
}
